export default __webpack_public_path__ + "static/media/openIcon.ed4c7e72.svg";